import CustomFieldsService from "@/services/bytepro/customFields.service";

export const customFieldsApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    get({ commit }, fileDataId) {
      return CustomFieldsService.get(fileDataId).then(
        (resp) => {
          commit("dummy", "CustomFieldsService.get - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "CustomFieldsService.get - error");
          return Promise.reject(error.response);
        }
      );
    },
    update({ commit }, { customFields, fileDataId }) {
      return CustomFieldsService.update(customFields, fileDataId).then(
        (resp) => {
          commit("dummy", "CustomFieldsService.update - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "CustomFieldsService.update - error");
          return Promise.reject(error.response);
        }
      );
    },
    checkConcurrentWork({ commit }, { fileDataId }) {
      return CustomFieldsService.checkConcurrentWork(fileDataId).then(
        (resp) => {
          commit("dummy", "CustomFieldsService.checkConcurrentWork - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "CustomFieldsService.checkConcurrentWork - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
